import { Box, Typography, useTheme } from "@mui/material";
import React from "react";

const PageHeader = ({
    title,
    content,
    color,
    buttonContent
}) => {
    const theme = useTheme();
    return (
        <Box
            sx={{
                background: theme.palette.primary.default,
                padding: '15px 15px 15px 15px',
                borderRadius: 1,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
            }}
        >
            <Box>
                <Typography variant="h5" sx={{  color: color || theme.palette.text.light }}>{title}</Typography>
                {content}
            </Box>
            {buttonContent}
        </Box>
    )
}

export default PageHeader;